"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _button = _interopRequireDefault(require("../button"));

require("./pageable-grid-list.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// 400 pixel scroll offset for mobile infinite scroll.
var SCROLL_OFFSET = 400;
/**
 * Pageable grid list. If `shouldPage` isn't passed in as prop, this will
 *  not page.
 *
 * If `shouldPage` is passed:
 * Renders a grid of paged items, that are multiples of items per page
 * which is passed in `props`. Note that this DOES NOT support server
 * pagination. All data required for pagination must be ready at initial
 * render.
 */

var PageableGridList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PageableGridList, _React$Component);

  function PageableGridList(props) {
    var _this;

    _classCallCheck(this, PageableGridList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PageableGridList).call(this, props));
    _this.state = {
      page: 1
    }; // memoized array for visible items.

    _this.visibleItems = [];
    _this.incrementPage = _this.incrementPage.bind(_assertThisInitialized(_this));
    _this.getVisibleItems = _this.getVisibleItems.bind(_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.removeScrollListener = _this.removeScrollListener.bind(_assertThisInitialized(_this)); // setup scroll listener

    _this.gridRef = _react["default"].createRef();
    _this.throttledScroll = _lodash["default"].throttle(_this.handleScroll, 200);
    return _this;
  } // Add scroll listener if `shouldPage`


  _createClass(PageableGridList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Add scroll listener to grid on client
      var shouldPage = this.props.shouldPage;

      if (shouldPage) {
        this.gridRef.current.addEventListener('scroll', this.throttledScroll);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Cancel scroll listener
      this.removeScrollListener();
    }
    /**
     * Memoized getter for paged items.  We show `itemsPerPage` cards
     * at a time in the desktop grid view.
     * @param {Array} items full array of items
     */

  }, {
    key: "getVisibleItems",
    value: function getVisibleItems() {
      var _this$props = this.props,
          itemsPerPage = _this$props.itemsPerPage,
          listItems = _this$props.listItems;
      var page = this.state.page;
      var numPagedItems = page * itemsPerPage;

      if (this.visibleItems.length < numPagedItems) {
        this.visibleItems = listItems.slice(0, numPagedItems);
      }

      return this.visibleItems;
    }
  }, {
    key: "removeScrollListener",
    value: function removeScrollListener() {
      this.throttledScroll.cancel();
      this.gridRef.current.removeEventListener('scroll', this.throttledScroll);
    }
    /**
     * Handle grid scroll.  Used to infinite scroll mobile view.
     */

  }, {
    key: "handleScroll",
    value: function handleScroll() {
      var listItems = this.props.listItems; // Have we loaded all the items yet?

      if (this.getVisibleItems().length < listItems.length) {
        var _this$gridRef$current = this.gridRef.current,
            clientWidth = _this$gridRef$current.clientWidth,
            scrollWidth = _this$gridRef$current.scrollWidth,
            scrollLeft = _this$gridRef$current.scrollLeft; // if grid is overflowed horizontally, we're on mobile.

        if (scrollWidth > clientWidth) {
          var rightEdge = scrollLeft + clientWidth; // If rightEdge of grid is within SCROLL_OFFSET pixels of end, load more items

          if (scrollWidth - rightEdge < SCROLL_OFFSET) {
            this.incrementPage();
          }
        }
      } else {
        // All items have been loaded, no longer need to scroll.
        this.removeScrollListener();
      }
    }
    /**
     * Increment the page to trigger a re-render and show the
     * next set of items.
     */

  }, {
    key: "incrementPage",
    value: function incrementPage() {
      var page = this.state.page;
      this.setState({
        page: page + 1
      });
    }
  }, {
    key: "render",
    value: function render() {
      // Get paged/memoized list of items.
      var _this$props2 = this.props,
          className = _this$props2.className,
          listItems = _this$props2.listItems,
          showMoreText = _this$props2.showMoreText,
          swipeToShowMoreText = _this$props2.swipeToShowMoreText,
          title = _this$props2.title,
          shouldPage = _this$props2.shouldPage;
      var items = shouldPage ? this.getVisibleItems(listItems) : listItems;
      var titleElement = title ? _react["default"].createElement("h2", {
        className: "title"
      }, title) : null;
      var showMoreClasses = '';
      var showMoreButton;

      if (shouldPage && items.length < listItems.length) {
        showMoreClasses = 'moreItems';
        showMoreButton = _react["default"].createElement(_button["default"], {
          className: "button",
          type: "secondary",
          onClick: this.incrementPage
        }, showMoreText);
      }

      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])('PageableGridList', className)
      }, titleElement, _react["default"].createElement("div", {
        className: "cards-grid",
        ref: this.gridRef
      }, items), _react["default"].createElement("div", {
        className: "showMore ".concat(showMoreClasses)
      }, _react["default"].createElement("div", {
        className: "text"
      }, swipeToShowMoreText), showMoreButton));
    }
  }]);

  return PageableGridList;
}(_react["default"].Component);

PageableGridList.propTypes = {
  className: _propTypes["default"].string,
  itemsPerPage: _propTypes["default"].number,
  listItems: _propTypes["default"].arrayOf(_propTypes["default"].node),
  showMoreText: _propTypes["default"].string,
  shouldPage: _propTypes["default"].bool,
  swipeToShowMoreText: _propTypes["default"].string,
  title: _propTypes["default"].string
};
PageableGridList.defaultProps = {
  className: null,
  itemsPerPage: 8,
  listItems: [],
  showMoreText: 'See More',
  shouldPage: false,
  swipeToShowMoreText: 'Swipe To See More',
  title: null
};
var _default = PageableGridList;
exports["default"] = _default;